module.exports = __webpack_public_path__ + "static/media/logo-bright@2x.ea452954.png";